import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { User } from "../types";
import request from "../apis/request";
import { FirebaseError } from "firebase/app";
import { APIResponse, UserCreateDto } from "../types/apiTypes";
import { useNavigate } from "react-router-dom";
import { EMAIL_REGEX, PASSWORD_REGEXP_PATTERN_1 } from "../common/constants";
import Loading from "../components/common/Loading";
import { useTranslation } from "react-i18next";

const RegisterCard = styled("div")({
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
});

interface RegisterProps {}

const Register = ({}: RegisterProps) => {
  const [inputUserId, setInputUserId] = useState("");
  const [inputUserPw, setInputUserPw] = useState("");
  const [inputUserConfirmPw, setInputUserConfirmPw] = useState("");
  const [isTermAgreement, setIsTermAgreement] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const { t: tCommon } = useTranslation("common");
  const { t: tError } = useTranslation("errors");

  const handleRegister = async () => {
    setIsProcessing(true);
    try {
      if (!inputUserId || !EMAIL_REGEX.test(inputUserId)) {
        throw new Error(tError("warn.invalidEmail"));
      }
      if (
        !inputUserPw ||
        !(inputUserPw.length >= 8 && inputUserPw.length <= 16)
      ) {
        throw new Error(tError("warn.invalidLength_8_16"));
      }
      if (!inputUserPw || !PASSWORD_REGEXP_PATTERN_1.test(inputUserPw)) {
        throw new Error(tError("warn.invalidPassword"));
      }
      if (!inputUserPw || inputUserPw !== inputUserConfirmPw) {
        throw new Error(tError("warn.invalidConfirmPasswd"));
      }
      if (!isTermAgreement) {
        alert(tError("alert.reqAgreeTerms"));
        return;
      }

      request<APIResponse<User, UserCreateDto>>({
        method: "POST",
        url: "registerUser",
        data: { email: inputUserId, pass: inputUserPw },
      });

      alert(tError("info.userRegistered"));

      navigate("/login");
    } catch (error: any) {
      let message = "";
      if (error instanceof FirebaseError) {
        message = error.message;
        console.error("ユーザ登録 error: ", error.code, error.message);
      } else {
        message = error?.message ? error.message : "System Error";
      }
      const alertMessage = tError("warn.registerUser") + " " + message;
      alert(alertMessage);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleAgreement = () => {
    setIsTermAgreement(!isTermAgreement);
    console.log(isTermAgreement);
  };

  return (
    <Container maxWidth="sm">
      <RegisterCard>
        <Typography variant="h5" gutterBottom>
          {/* 新規登録（メールアドレス） */}
          {tCommon("auth.register")}
        </Typography>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={tCommon("auth.email")}
          value={inputUserId}
          onChange={(e) => setInputUserId(e.target.value)}
        />
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={tCommon("auth.password")}
          type="password"
          value={inputUserPw}
          onChange={(e) => setInputUserPw(e.target.value)}
        />
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ display: "block", mt: 0.5, mb: 1, px: 0.5 }}
        >
          {tCommon("auth.ruleOfPass")}
        </Typography>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={tCommon("auth.confirmPassword")}
          type="password"
          value={inputUserConfirmPw}
          onChange={(e) => setInputUserConfirmPw(e.target.value)}
        />
        <FormGroup>
          <FormControlLabel
            required
            control={<Checkbox onChange={handleAgreement} />}
            label={tCommon("auth.agreeTerms")}
          />
        </FormGroup>
        <Button
          sx={{ marginTop: "20px" }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleRegister}
        >
          {tCommon("auth.register")}
        </Button>
      </RegisterCard>
      {isProcessing && (
        <Loading message={tCommon("messages.processing")} blurBackdrop={true} />
      )}
    </Container>
  );
};

export default Register;
